import EventDispatcher from './events/EventDispatcher';

var dispatcher = new EventDispatcher();
var _MAX_DELTA = 250;

/**
 * @class
 * @inheritDoc
 * @classdesc Глобальный тикер
 */
class Ticker  {
    static tick(e) {
        /**
         * Глобальный тик
         * @event Ticker#tick
         */
        dispatcher.emit("tick", Ticker.getInfo());
    }

    static get MAX_DELTA() {
        return _MAX_DELTA;
    }
    static set MAX_DELTA(val) {
        _MAX_DELTA = val;
    }

    static getInfo() {
        return {
            ticker: PIXI.ticker.shared,
            target: Ticker,
            delta: Math.min(PIXI.ticker.shared.elapsedMS, Ticker.MAX_DELTA)
        }
    }

    /** Подписка на ивент (tick, start, stop) */
    static on(event, fn, context) {
        dispatcher.on(event, fn, context);
    }

    /** Единоразовая подписка на ивент */
    static once(event, fn, context) {
        dispatcher.once(event, fn, context);
    }

    static removeListener(event, fn, context, once) {
        dispatcher.removeListener(event, fn, context, once);
    }

    /** Отписка от ивента */
    static off(event, fn, context, once) {
        dispatcher.off(event, fn, context, once);
    }

    /** Остановка тикера */
    static stop() {
        PIXI.ticker.shared.stop();
        /**
         * Остановка тикера
         * @event Ticker#stop
         */
        dispatcher.emit("stop", Ticker.getInfo());
    }

    /** Запуск тикера */
    static start() {
        PIXI.ticker.shared.start();
        /**
         * Старт тикера
         * @event Ticker#start
         */
        dispatcher.emit("start", Ticker.getInfo());
    }
}

PIXI.ticker.shared.add(Ticker.tick);

export default Ticker;